/**
 * ptosis.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import PtosisVue from './views/ptosis/ptosis.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/ptosis.js'

async function goApp() {
    const app = createApp(PtosisVue)
    registerPlugins(app, 'ptosis')
    await store.dbinit()
    app.mount('#app')
}

goApp()
